/**
 *  All api related to user
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import config from '../../config'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchUser(userId) {
  const params = {
    includes: [
      'affiliation_data',
      'order_price_information',
      'meta',
    ]
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchUser',
    () => source.cancel('fetchUser: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/${userId}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      user: data.user
    }))
}

export function updateUser({userId, user}) {
  if (_.isEmpty(user)) return
  const tenantCode = config.get('api.tenantCode')
  const {
    phone,
    ...rest
  } = user
  const data = _.isEmpty(tenantCode) || _.isEmpty(phone)
    ? { user }
    : {
      user: {
        tenantPhone: phone,
        ...rest
      }
    }
  const params = {
    includes: []
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'updateUser',
    () => source.cancel('updateUser: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/${userId}`,
      method: 'put',
      data: {
        data,
      },
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      user: data.user
    }))
}

export function deleteUser(userId) {
  const params = {}
  const source = CancelToken.source()
  cancelRequest.add(
    'deleteUser',
    () => source.cancel('deleteUser: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/${userId}`,
      method: 'delete',
      data: {
        data: {user: {}},
      },
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
}

/**
 * createUserResetPasswordRequest
 *
 * @param {*} user Email to receive token
 *    "user": {
 *      "email": "leonardo@tofugear.com", // or
 *      // "phone": "+85212345678"
 *    }
 */
export function createUserResetPasswordRequest(user) {
  const params = {}
  const source = CancelToken.source()
  cancelRequest.add(
    'createUserResetPasswordRequest',
    () => source.cancel('createUserResetPasswordRequest: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/reset_password_request`,
      method: 'post',
      data: {
        data: {user},
      },
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
}

/**
 * createUserResetPassword
 *
 * @param {*} user new password with token
 *    "user": {
 *      "password": "aaaaa",
 *      "password_confirmation": "bbbb",
 *      "reset_password_token": "cccc"
 *    }
 */
export function createUserResetPassword(user) {
  const params = {}
  const source = CancelToken.source()
  cancelRequest.add(
    'createUserResetPassword',
    () => source.cancel('createUserResetPassword: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/reset_password`,
      method: 'post',
      data: {
        data: {user},
      },
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
}

export function createUsersOmniAuthOtps(data) {
  const payload = {
    data
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'createUsersOmniAuthOtps',
    () => source.cancel('createUsersOmniAuthOtps: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/omni_auth_otps`,
      method: 'post',
      data: payload,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      console.log(response)
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      omniAuthOtp: data.omniAuthOtp
    }))
}

export function fetchUserLoyaltyInformation(userId) {
  const params = {
    includes: [
      'next_customer_rank',
      'loyalty_base_points_information',
    ]
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchUserLoyaltyInformation',
    () => source.cancel('fetchUserLoyaltyInformation: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/${userId}/loyalty_information`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      loyaltyInformation: data.loyaltyInformation
    }))
}

export function fetchUserStoredValue(userId, params = {}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchUserStoredValue',
    () => source.cancel('fetchUserStoredValue: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `users/${userId}/stored_value_balance`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      storedValueBalances: data.storedValueBalances
    }))
}
